import { onUnmounted, Ref, watch } from "@vue/composition-api";
import { IS_BROWSER } from "@/lib/browserUtils";

export default function useBeforeUnloadTab(message: string, forceDisableCheck?: Ref<boolean>) {
  if (!IS_BROWSER) {
    return;
  }
  const exitConfirmationMessage = (e: BeforeUnloadEvent) => {
    (e || window.event).returnValue = message; //Gecko + IE
    return message; //Webkit, Safari, Chrome
  };

  if (forceDisableCheck) {
    watch(forceDisableCheck, forceDisableCheck => {
      if (forceDisableCheck) {
        window.removeEventListener("beforeunload", exitConfirmationMessage);
      } else {
        window.addEventListener("beforeunload", exitConfirmationMessage);
      }
    });
  }

  onUnmounted(() => {
    window.removeEventListener("beforeunload", exitConfirmationMessage);
  });
}
